
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "@/store";
import permission from './permission.js'

import '@/assets/style.css'
import "./vant/vant.js";
// 日期格式插件
import moment from 'moment';

Vue.prototype.$moment = moment
// 默认错误图片
Vue.prototype.$imgError = '/static/img/default.png';

Vue.prototype.$fileUrl = "https://file.nuanxinwo.vip/"; // 阿里云oss地址


/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js